import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  OnDestroy,
  TemplateRef
} from '@angular/core';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') clazz = 'expandir-flex';
  title = 'seira';

  logosOcultas = false;
  mostrarLogos = true;
  isScrolled = false;
  referenciaAreaTemporaria: TemplateRef<any>; 

  @HostListener('scroll', ['$event'])
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    const hostScroll = this.elRef.nativeElement.scrollTop || 0;
    const windowScroll = window.scrollY || document.documentElement.scrollTop || 0;
    this.isScrolled = hostScroll > 0 || windowScroll > 0;
  }

  private routerSub: Subscription;

  constructor(private router: Router, private elRef: ElementRef) {
    this.routerSub = this.router.events
      .pipe(
        filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        this.mostrarLogos = this.deveMostrarLogos(event.urlAfterRedirects || event.url);
      });
  }

  ngAfterViewInit() {
    $('#app-loading').hide();
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }


  private deveMostrarLogos(url: string): boolean {
    // Remove query params e hash da URL
    const baseUrl = url.split('?')[0].split('#')[0];

    // Rotas onde as logos devem aparecer
    const rotasComLogo = ['', '/', '/visao-geral'];

    return rotasComLogo.includes(baseUrl);
  }
}
